// Client half of backend/geo_lock.py: signs API requests so only the Xpattern app can pull geometry, and unlocks the AES-CTR
// locked outlines the server sends customers (key = app key | user id | pattern id | version — never stored, derived per use).
const KEY = process.env.REACT_APP_APP_SIG_KEY;
const enc = new TextEncoder();
const sha256 = async (s) => new Uint8Array(await crypto.subtle.digest("SHA-256", enc.encode(s)));
const hex = (u8) => Array.from(u8, (b) => b.toString(16).padStart(2, "0")).join("");

export const signHeaders = async (method, path, token) => {
  const ts = String(Date.now());
  const nonce = hex(crypto.getRandomValues(new Uint8Array(8)));
  const sig = hex(await sha256(`${KEY}|${token || ""}|${method.toUpperCase()}|${path}|${ts}|${nonce}`));
  return { "X-Xp-Ts": ts, "X-Xp-Nonce": nonce, "X-Xp-Sig": sig };
};

export const userIdFromToken = (t) => {
  try { return JSON.parse(atob(t.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"))).sub || ""; } catch { return ""; }
};

export const unlockItem = async (item, userId) => {
  const g = item?.geo;
  if (!g) return item;
  const version = item.version ?? "";
  const key = await crypto.subtle.importKey("raw", await sha256(`${KEY}|${userId}|${item.id}|${version}`), "AES-CTR", false, ["decrypt"]);
  const counter = (await sha256(`ctr|${item.id}|${version}|${userId}`)).slice(0, 16);
  const bytes = Uint8Array.from(atob(g.b), (c) => c.charCodeAt(0));
  const buf = new Uint8Array(await crypto.subtle.decrypt({ name: "AES-CTR", counter, length: 128 }, key, bytes));
  const dv = new DataView(buf.buffer);
  let pos = 0;
  const take = (n) => { const out = new Array(n); for (let i = 0; i < n; i++) { out[i] = [dv.getFloat64(pos, true), dv.getFloat64(pos + 8, true)]; pos += 16; } return out; };
  for (const part of g.parts) item[part.k] = Array.isArray(part.n) ? part.n.map(take) : take(part.n);
  delete item.geo;
  return item;
};

export const unlockList = async (list, userId) => {
  if (!Array.isArray(list) || !list.some((x) => x?.geo)) return list;
  for (const item of list) await unlockItem(item, userId);
  return list;
};
